import { Box, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import TableUse from "components/Atoms/SharedComponents/CRUD/table-use";

export default function OrderSummary({
  title,
  columns,
  details,
  getReturnRequestItem,
  products,
  wrapper,
  giftCard,
  currency,
}) {
  const { t } = useTranslation();
  // const products = details?.cart?.cart_items;
  // const wrapper = details?.cart?.wrapper;
  // const giftCard = details?.cart?.gift_card;
  // const currency = details?.cart?.currency?.name;

  const prepareList = () => {
    let list = [];
    products && list?.push(...products);
    // wrapper and giftcard are not a part of the cart items
    // and have different structure
    // !so they have to be manually structured & added
    wrapper &&
      list?.returnable?.push({
        variant: {
          name: wrapper?.title,
          image: wrapper?.wrapper_image,
          price_after_discount: wrapper?.wrap_variant?.price_after_discount,
        },
        total_amount: wrapper?.cost_after_discount,
      });
    giftCard &&
      list?.push({
        isGiftCard: true,
        giftCardData: giftCard,
        variant: {
          name: giftCard?.card?.name,
          image: giftCard?.card?.image,
          price_after_discount: giftCard?.card?.price_after_discount,
        },
        total_amount: giftCard?.card?.price_after_discount,
      });
    return list;
  };

  const mappedData = prepareList()?.map((data, index) => {
    const isWrapper = data?.wrapper;
    const height = "70px";
    return {
      ...data,
      id: (
        <Stack gap={2}>
          {index + 1}
          {isWrapper && <Stack sx={{ height }} />}
        </Stack>
      ),
      product: (
        <Stack gap={2}>
          <Stack direction="row" alignItems="center" gap={1}>
            <Box component="img" src={data?.variant?.image} width="50px" />
            <div>
              <Typography fontWeight="500">{data?.variant?.name}</Typography>
              {data?.variant?.option_values?.length > 0 && (
                <Stack mt={1} gap={0.5}>
                  <Typography sx={{ color: "#9F9F9F" }}>
                    {t("orders.label_options")}
                  </Typography>
                  {data?.variant?.option_values?.map((option, idx) => (
                    <Stack
                      key={idx}
                      direction="row"
                      alignItems="center"
                      gap={1}
                    >
                      {option?.presentation && (
                        <Box
                          sx={{
                            width: 16,
                            height: 16,
                            borderRadius: 0.5,
                            bgcolor: option?.presentation || "transparent",
                            border: "1px solid #e0e0e0",
                          }}
                        />
                      )}
                      <Typography fontWeight="500">{option?.name}</Typography>
                    </Stack>
                  ))}
                </Stack>
              )}
            </div>
          </Stack>
          {isWrapper && (
            <Stack>
              <Typography sx={{ color: "#9F9F9F" }}>
                {t("orders.label_wrapping")}
              </Typography>
              <Stack direction="row" alignItems="center" gap={1}>
                <Box
                  component="img"
                  src={data?.wrapper?.wrapper_image}
                  width="50px"
                />
                <Typography fontWeight="500">{data?.wrapper?.title}</Typography>
              </Stack>
              {data?.wrapper?.ribbon && (
                <Stack mt={1} gap={0.5}>
                  <Typography sx={{ color: "#9F9F9F" }}>
                    {t("orders.label_ribbon")}
                  </Typography>
                  <Stack direction="row" alignItems="center" gap={1}>
                    <Box
                      sx={{
                        width: 16,
                        height: 16,
                        borderRadius: 0.5,
                        bgcolor:
                          data?.wrapper?.ribbon?.presentation || "transparent",
                        border: "1px solid #e0e0e0",
                      }}
                    />
                    <Typography fontWeight="500">
                      {data?.wrapper?.ribbon?.name}
                    </Typography>
                  </Stack>
                </Stack>
              )}
              {data?.wrapper?.wrap_variant && (
                <Stack mt={1} gap={0.5}>
                  <Typography sx={{ color: "#9F9F9F" }}>
                    {t("orders.label_wrap_variant")}
                  </Typography>
                  <Stack direction="row" alignItems="center" gap={1}>
                    <Box
                      sx={{
                        width: 16,
                        height: 16,
                        borderRadius: 0.5,
                        bgcolor:
                          data?.wrapper?.wrap_variant?.color?.presentation ||
                          "transparent",
                        border: "1px solid #e0e0e0",
                      }}
                    />
                    <Typography fontWeight="500">
                      {data?.wrapper?.wrap_variant?.color?.name}
                    </Typography>
                  </Stack>
                </Stack>
              )}
            </Stack>
          )}
          {data?.isGiftCard && (
            <Stack mt={1} gap={0.5}>
              {data?.giftCardData?.title && (
                <Stack direction="row" alignItems="center" gap={1}>
                  <Typography sx={{ color: "#9F9F9F" }}>
                    {t("orders.label_title") || "Title"}:
                  </Typography>
                  <Typography fontWeight="500">
                    {data?.giftCardData?.title}
                  </Typography>
                </Stack>
              )}
              {data?.giftCardData?.message && (
                <Stack direction="row" alignItems="center" gap={1}>
                  <Typography sx={{ color: "#9F9F9F" }}>
                    {t("orders.label_message") || "Message"}:
                  </Typography>
                  <Typography fontWeight="500">
                    {data?.giftCardData?.message}
                  </Typography>
                </Stack>
              )}
              {data?.giftCardData?.attachment_link && (
                <Stack direction="row" alignItems="center" gap={1}>
                  <Typography sx={{ color: "#9F9F9F" }}>
                    {t("orders.label_attachment") || "Attachment"}:
                  </Typography>
                  <a
                    href={data?.giftCardData?.attachment_link}
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      fontWeight: "500",
                      color: "#1976d2",
                      textDecoration: "underline",
                    }}
                  >
                    {t("common.view") || "View"}
                  </a>
                </Stack>
              )}
              {data?.giftCardData?.voice_message_link && (
                <Stack direction="row" alignItems="center" gap={1}>
                  <Typography sx={{ color: "#9F9F9F", whiteSpace: "nowrap" }}>
                    {t("orders.label_voice_message") || "Voice Message"}:
                  </Typography>
                  <audio
                    controls
                    src={data?.giftCardData?.voice_message_link}
                    style={{ height: "30px", maxWidth: "200px" }}
                  />
                </Stack>
              )}
            </Stack>
          )}
        </Stack>
      ),
      sku: (
        <Stack gap={2}>
          <Typography fontWeight="500">{data?.variant?.sku}</Typography>
          {isWrapper && <Stack sx={{ height }}></Stack>}
        </Stack>
      ),
      price: (
        <Stack gap={2}>
          {data?.variant?.price_after_discount} {currency}
          {isWrapper && (
            <Stack sx={{ height }}>
              <Typography sx={{ color: "#9F9F9F" }}>
                {t("orders.label_price")}
              </Typography>
              <Typography fontWeight="400">
                {data?.wrapper?.cost_after_discount} {currency}
              </Typography>
              {data?.wrapper?.ribbon && (
                <>
                  <Typography sx={{ color: "#9F9F9F", mt: 1 }}>
                    {t("orders.label_ribbon_price")}
                  </Typography>
                  <Typography fontWeight="400">
                    {data?.wrapper?.ribbon?.price_after_discount}{" "}
                    {data?.wrapper?.ribbon?.currency?.name || currency}
                  </Typography>
                </>
              )}
            </Stack>
          )}
        </Stack>
      ),
      quantity: (
        <Stack gap={2}>
          {data?.quantity ? data?.quantity : "-"}
          {isWrapper && <Stack sx={{ height }} />}
        </Stack>
      ),
      total_price: (
        <Stack gap={2}>
          {isWrapper
            ? data?.total_amount + data?.wrapper?.cost_after_discount
            : data?.total_amount}{" "}
          {currency}
          {isWrapper && <Stack sx={{ height }} />}
        </Stack>
      ),
    };
  });

  return (
    <Stack sx={{ backgroundColor: "white" }}>
      <Stack width="50%" px={3} pt={3} mb={-3}>
        <Typography fontSize="32px" fontWeight="500" fontFamily="Cairo">
          {title}
        </Typography>
      </Stack>

      <TableUse
        list={mappedData}
        columnsData={columns}
        setTableData={() => void 0}
        setFilterObj={() => void 0}
      />
    </Stack>
  );
}
